import { takeEvery, all, put, call } from 'redux-saga/effects'
import actions from "./actions"
import { getClientOwnerFromWorkspaceApi } from "../../services/client.service"
import { AxiosResponse } from 'axios';

function* GET_CLIENT_OWNER(action: {payload: string, type: any}){
    try{
        const response: AxiosResponse<any> = yield call(getClientOwnerFromWorkspaceApi, action.payload);
        if(response){
            yield put({
                type: actions.SET_CLIENT_OWNER,
                payload: response.data
            })
        }
    }
    catch (e) {

    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.GET_CLIENT_OWNER, GET_CLIENT_OWNER),
    ])
}
